export enum TimeUnit {
  HOUR = 'hour',
  DAY = 'day',
  WEEK = 'week',
  MONTH = 'month',
  YEAR = 'year',
}

export type QuestionUnit = TimeUnit;

export enum QuestionKey {
  READY_FOR_JOB_OFFERS = 'ready_for_job_offers',
  CERTIFICATES_AND_LICENSES = 'certificates_and_licenses',
  SALARY = 'salary',
  SHIFTS = 'shifts',
  AVAILABLE_DAYS = 'available_days',
  LIMITATIONS_AND_PREFERENCES = 'limitations_and_preferences',
  WORKING_HOURS_PER_WEEK = 'working_hours_per_week',
  LANGUAGES = 'languages',
}

export type RangeValue = {
  min: number;
  max: number;
};

export enum InputType {
  RANGE_SLIDER = 'range_slider',
  RANGE_INPUT = 'range_input',
  STRING = 'string',
  ARRAY = 'array',
  BOOLEAN = 'boolean',
}

export type RequirementField<T> = {
  question_key: QuestionKey;
  job_requirements?: T;
  confirmed_info?: T;
  is_answered: boolean;
  input_type?: InputType;
  unit?: QuestionUnit;
  is_required?: boolean;
};

export type CandidateRequirementsDTO = {
  [QuestionKey.READY_FOR_JOB_OFFERS]: RequirementField<boolean>;
  [QuestionKey.CERTIFICATES_AND_LICENSES]: RequirementField<string[]>;
  [QuestionKey.SALARY]: RequirementField<RangeValue>;
  [QuestionKey.SHIFTS]: RequirementField<string[]>;
  [QuestionKey.AVAILABLE_DAYS]: RequirementField<string[]>;
  [QuestionKey.LIMITATIONS_AND_PREFERENCES]: RequirementField<string[]>;
  [QuestionKey.WORKING_HOURS_PER_WEEK]: RequirementField<RangeValue>;
  [QuestionKey.LANGUAGES]: RequirementField<string[]>;
};

export type QuestionnaireAnswerValue = boolean | string[] | RangeValue;
